import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { apiService } from '../../../../service/api.service'
import { UnidadEducativaModel, ResponseUnidadEducativaModel, EncargadaModel, ResponseEncargadaModel, EstamentoModel } from '../../../../model/Identificacion.model'
import { JardinModel} from '../../../../model/Jardin.model'
import { ResponseEquipoPedagogicoModel,EquipoPedagogicoModel } from '../../../../model/Identificacion.model'
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ModalEditarMiembroComponent } from '../dialogs/modal-miembros-equipo-pedagogico/modal-miembros-equipo-pedagogico.component'
import { ResponseEstamentoModel } from '../../../../model/Identificacion.model'
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactoModel } from 'src/app/model/Contacto.model';
import Swal from 'sweetalert2';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-identificacion',
  templateUrl: './identificacion.component.html',
  styleUrls: ['./identificacion.component.css']
})
 
export class IdentificacionComponent implements OnInit {

  @Input() simulacion: boolean;
  @ViewChild('modalSolicitarCambios', { static: true }) modalSolicitarCambios: TemplateRef<any>;
  selected = new FormControl(0);
  uniEducativa = new UnidadEducativaModel(); 
  datosDirec = new EncargadaModel();
  dataJardin = new JardinModel();
  estamentos = new ResponseEstamentoModel();
  responseEquipoPedagogico = new ResponseEquipoPedagogicoModel();
  @ViewChild('divSpinner') divSpinner:ElementRef;
  cargando = true;
  formContacto = new ContactoModel();
  consulta : string;


  constructor(
    private modal: NgbModal,
    private api: apiService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {     
    this.consulta = "";
    this.cargando = true;
    this.cargaInicial();
    
  }

  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
    this.unidadEducativa(this.dataJardin);
    this.getDirectora(this.dataJardin);
    this.getEstamentos();
    this.getEquipoPedagogico(this.dataJardin);
  }

  unidadEducativa(dataJardin:JardinModel){
      this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
        this.uniEducativa = response.payload;  
      },
      (err) => {
        console.log(err)
      });      
  }

  getDirectora(dataJardin:JardinModel){
      this.api.API_POST_obtenerDirectora(dataJardin.id).subscribe((response: ResponseEncargadaModel) => {
        this.datosDirec = response.payload;
      },
      (err) => {
        console.log(err)
      })
  }

  getEquipoPedagogico(dataJardin:JardinModel){
   
    this.api.API_POST_obtenerEquipoPedagogico(dataJardin.id).subscribe((response: ResponseEquipoPedagogicoModel) => {
      this.responseEquipoPedagogico = response;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      console.log(err)
    })
  }




  getEstamentos(){
    this.api.API_POST_obtenerEstamentos().subscribe((response: ResponseEstamentoModel) =>{
      this.estamentos = response;  
      this.getEquipoPedagogico(this.api.dataJardin);   
    },(err) => {
      console.log(err)
    })
  }
  
  nuevoMiembro(){
 
    const miembro = new EquipoPedagogicoModel();
    const dialogRef = this.dialog.open(ModalEditarMiembroComponent, {
      disableClose: true ,
      data: {dataMiembro: miembro, estamentos:this.estamentos, tipoModal: 'nuevo'}
    }); 
    dialogRef.afterClosed().subscribe(result => {
   
      if(result=='refresh'){
        this.getEquipoPedagogico(this.api.dataJardin);

      }
    });
  }

  editarMiembro(miembro : EquipoPedagogicoModel){

    const dialogRef = this.dialog.open(ModalEditarMiembroComponent, {
      disableClose: true ,
      data: {dataMiembro: miembro, estamentos:this.estamentos, tipoModal: 'editar'}
    });

    dialogRef.afterClosed().subscribe(result => {
   
      if(result=='refresh'){
        this.getEquipoPedagogico(this.api.dataJardin);

      }
    });

  }

  eliminarMiembro(miembro : EquipoPedagogicoModel){
    const estamentoNull = new ResponseEstamentoModel();
    const dialogRef = this.dialog.open(ModalEditarMiembroComponent, {
      disableClose: true ,
      data: {dataMiembro: miembro, estamentos: estamentoNull, tipoModal: 'eliminar'}
    }); 

    dialogRef.afterClosed().subscribe(result => {
    
      if(result=='refresh'){
        this.getEquipoPedagogico(this.api.dataJardin);

      }
    });
  }

  abrirModalConsulta(){
    this.modal.open(this.modalSolicitarCambios, { size: 'lg' });
  }



  enviar(){
    this.formContacto.idJardin = this.api.dataJardin.id;
    this.formContacto.asunto = "Solicitar Cambios"
    this.formContacto.consulta = this.consulta;
    this.divSpinner.nativeElement.style.display='';
    if(this.consulta != ""){
      this.api.API_POST_crearConsulta(this.formContacto).subscribe((response) => {
        this.formContacto = new ContactoModel();
        this.consulta = "";
        this.divSpinner.nativeElement.style.display='none';
        close(); this.modal.dismissAll();
        Swal.fire({
          icon: 'success',
          title: 'Su Consulta se ha Enviado',
          confirmButtonText: 'OK'
        })
      },
      (err) => {
        console.log(err)
      })
    }else{
      this.divSpinner.nativeElement.style.display='none';
      Swal.fire({
        title: 'Error!',
        text: 'El Mensaje es Obligatorio',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }
  }

  close(){
    this.modal.dismissAll();
  }

  irA(){
    this.api.emitDireccionamiento('contacto');
  }

}